import { Form2 } from "../../misc/Form2";
import { Column } from "../../misc/Column";
import { RadioButtonGroupInput, ReferenceArrayInput, required, SelectArrayInput, TextInput } from "react-admin";
import { VehicleFormToolbar } from "../../misc/VehicleFormToolbar";
import { EntitledInstructorsInput } from "../../inputs/EntitledInstructorsInput";
import { type SxProps } from "@mui/material";
import { useAutovioContext } from "../../hooks/useAutovioContext";

export function CarForm({ mode, sx }: { mode: "create" | "edit"; sx?: SxProps }) {
  const [{ drivingSchoolId }] = useAutovioContext();

  if (!drivingSchoolId) {
    return null;
  }

  return (
    <Form2
      warnWhenUnsavedChanges
      defaultValues={{
        type: "car",
        drivingSchoolId,
        name: "",
        notes: "",
        plateNumber: "",
        gearType: null,
        adasIds: [],
        entitledInstructorIds: [],
      }}
    >
      <Column sx={sx}>
        <TextInput label="Name" source="name" autoFocus={mode === "create"} validate={required()} />
        <TextInput label="Notizen" source="notes" />
        <TextInput label="Kennzeichen" source="plateNumber" validate={required()} sx={{ width: "150px" }} />
        <RadioButtonGroupInput
          source="gearType"
          label="Getriebe-Typ"
          choices={[
            { id: "electric", name: "Elektrisch" },
            { id: "automatic", name: "Automatik" },
            { id: "manual", name: "Schaltwagen" },
          ]}
          validate={required()}
        />
        <ReferenceArrayInput source="adasIds" reference="adas">
          <SelectArrayInput label="Assistenzsysteme" defaultValue={[]} sx={{ minWidth: { xs: 0, sm: "337px" } }} />
        </ReferenceArrayInput>
        <EntitledInstructorsInput source="entitledInstructorIds" />
        <VehicleFormToolbar />
      </Column>
    </Form2>
  );
}
